// ============================================================================
// MODULAR ARITHMETIC OPERATIONS - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'modular-arithmetic',
  name: 'Modular Arithmetic Operations',
  category: 'Math',
  complexity: {
    time: 'O(1) for basic operations, O(log n) for exponentiation',
    space: 'O(1)'
  },
  description: 'Modular arithmetic operations include addition, subtraction, multiplication, division, and exponentiation under a modulus. Numbers wrap around when reaching the modulus value.'
};
export type MetaType = typeof meta;
